export const blockIconsSocialHealthAndSafetyNew = (
	<span className='material-symbols-outlined'>health_and_safety</span>
);
